module.exports = __webpack_public_path__ + "static/tuzagInsideWhite-020100d8bea3b57ebd95d2e6f510dfd3.svg";